export const iconFontAwesomeHumanitarianUsersRays = (
	<i className="fa-solid fa-users-rays"></i>
);
